import { IUserMeRequest } from '@/utils/interfaces'
import axios from './base'

export const getUserMe = (): Promise<IUserMeRequest> => axios.get('v2/users/me')
export const updateUserMe = (user: any): Promise<unknown> => axios.put(`/v2/users/me`, user)